import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=11544ea3"
import script from "./Pagination?vue&type=script&lang=ts&external"
export * from "./Pagination?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports